export default "__VITE_ASSET__CmbGHypM__"